import { render } from "./PacienteCita01.vue?vue&type=template&id=8b1ccd3c&scoped=true"
import script from "./PacienteCita01.vue?vue&type=script&lang=js"
export * from "./PacienteCita01.vue?vue&type=script&lang=js"

import "./PacienteCita01.vue?vue&type=style&index=0&id=8b1ccd3c&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1ccd3c"]])

export default __exports__